/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Vpedal_Step_InstallInputs */



/**
* | output |
* | --- |
* | "Install the vPedal 2015 API from vpedal.com and run the installer." |
*
* @param {Options_Pedal_Vpedal_Step_InstallInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_vpedal_step_install = /** @type {((inputs?: Options_Pedal_Vpedal_Step_InstallInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Vpedal_Step_InstallInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Install the vPedal 2015 API from vpedal.com and run the installer.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Install the vPedal 2015 API from vpedal.com and run the installer.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Install the vPedal 2015 API from vpedal.com and run the installer.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Install the vPedal 2015 API from vpedal.com and run the installer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Install the vPedal 2015 API from vpedal.com and run the installer.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Install the vPedal 2015 API from vpedal.com and run the installer.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Install the vPedal 2015 API from vpedal.com and run the installer.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Install the vPedal 2015 API from vpedal.com and run the installer.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Install the vPedal 2015 API from vpedal.com and run the installer.")
	return /** @type {LocalizedString} */ ("Install the vPedal 2015 API from vpedal.com and run the installer.")
});